import axios, { CancelTokenSource } from "axios"

export const cambiarContrasenaApi = async (Usuario:any, PasswordAnterior:any, PasswordNueva:any) => {
    const bodyCambiarContra = {Usuario : Usuario, 
        PasswordAnterior : PasswordAnterior, 
        PasswordNueva : PasswordNueva, 
        Url : ''}

    return axios.post('api/User/CambiarClave',bodyCambiarContra)
}

export const newPasswordByToken = async (recoveryToken: string, user:string, password: string) => {
    const data = {
        Password : password, 
        RecoveryToken : recoveryToken, 
        User: user
    };

    return axios.post('api/User/NewPasswordByToken', data)
}

export const verifyPasswordToken = async (user: string, recoveryToken: string, tkn: CancelTokenSource) => {
    return axios.get(`api/User/VerifyPasswordToken?user=${user}&token=${recoveryToken}`, {cancelToken: tkn.token})
}


